/* eslint-disable */
export default {
  unknown: '未知',
  multipleMatches: '多个匹配项',
  anonymous: '匿名',
  none: '无',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
